<template>
  <div>
      <a-row>
        <!-- <a-col :span="5">
          <a-input placeholder="作品名" v-model="queryParam.workName"></a-input>
        </a-col> -->
        <a-col :span="5">
          <a-input
            style="width: 150px"
            placeholder="学生名"
            v-model="queryParam.realname"
          ></a-input>
        </a-col>
        <!-- <a-col :span="5">
          <j-dict-select-tag
            style="width: 120px"
            placeholder="代码类型"
            v-model="queryParam.codeType"
            dictCode="code_type"
          />
        </a-col> -->
        <a-col :span="5">
          <!-- <j-dict-select-tag
            style="width: 120px"
            placeholder="状态"
            v-model="queryParam.workStatus"
            dictCode="work_status"
          /> -->
          <a-select style="width: 120px" v-model="queryParam.workStatus" @change="search">
            <a-select-option key="" :value="'1 2 3'">全部</a-select-option>
            <a-select-option key="1" :value="'1'">未批改</a-select-option>
            <a-select-option key="2" :value="'2 3'">已批改</a-select-option>
          </a-select>
        </a-col>
        <!-- <a-col :span="8">
          <a-radio-group v-model="queryParam.workScene" style="margin: 0 20px">
            <a-radio-button value="course">课程作业</a-radio-button>
            <a-radio-button value="additional">自定义教学</a-radio-button>
          </a-radio-group>
        </a-col> -->
        <a-col :span="4">
          <a-button type="primary" @click="search">查询</a-button>
        </a-col>
      </a-row>
      <a-divider/>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="rate" slot-scope="t">
          <a-rate :disabled="true" :value="t" />
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">批改</a>
          <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    <WorkReviewModal ref="modalForm" @finished="search" />
  </div>
</template>

<script>
import WorkReviewModal from "./modules/WorkReviewModal";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";

export default {
  name: "TeacherWorkList",
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    WorkReviewModal,
  },
  props: {
    isInner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "学生账号",
          align: "center",
          dataIndex: "username",
          width: 120,
          sorter: true,
        },
        {
          title: "学生姓名",
          align: "center",
          dataIndex: "realname",
          width: 120,
          sorter: true,
        },
        {
          title: "班级",
          align: "center",
          width: 100,
          dataIndex: "departId_dictText",
        },
        {
          title: "课程单元",
          align: "center",
          dataIndex: "unitName",
          width: 100,
        },
        {
          title: "代码类型",
          align: "center",
          width: 100,
          dataIndex: "codeType_dictText",
        },
        {
          title: "作品名",
          align: "center",
          dataIndex: "workName",
          width: 200,
        },
        {
          title: "状态",
          align: "center",
          width: 100,
          dataIndex: "workStatus_dictText",
        },
        {
          title: "评分",
          align: "center",
          width: 180,
          dataIndex: "score",
          sorter: true,
          scopedSlots: { customRender: "rate" },
        },
        {
          title: "首次提交时间",
          align: "center",
          width: 150,
          dataIndex: "createTime",
          sorter: true,
          customRender(v, r) {
            return r.createTime;
          },
        },
        {
          title: "最新提交时间",
          align: "center",
          width: 150,
          dataIndex: "updateTime",
          sorter: true,
          customRender(v, r) {
            return r.updateTime || r.createTime;
          },
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingWork/teacherCourseWork",
      },
      disableMixinCreated: true, //禁用mixin的created方法
      unitInfo: {},
    };
  },
  created() {
    if(this.isInner){
      this.columns.splice(2,3)
    }
    if (this.$route.query.departId) {
      this.queryParam.departId = this.$route.query.departId;
    }
    if (this.$route.query.unitId) {
      this.queryParam.unitId = this.$route.query.unitId;
    }
    if (this.$route.query.additionalWorkId) {
      this.queryParam.additionalWorkId = this.$route.query.additionalWorkId;
    }
    this.queryParam.workStatus = '1 2 3'
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadData(1);
      // teacherCourseWork(this.queryParam).then((res) => {
      //   this.dataSource = res.result.records;
      //   this.ipagination.total = res.result.total;
      //   this.loading = false;
      // });
    },
    open(record) {
      console.log(record);
      this.isInner = true;
      this.queryParam.departId = record.id;
      this.search();
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record);
    },
  },
};
</script>

<style lang="less" scoped>
</style>